import { Spin } from 'antd';
import PropTypes from 'prop-types';

// Styles
import styles from './styles.module.css';

const DashboardCard = ({ children, colSpan = 1, loading, id }) => {
  const colSpanConfig = ['md:w-1/2 xl:w-1/3', 'md:w-full xl:w-2/3', ''];
  const colSpanIndex = colSpan > colSpanConfig.length ? 0 : colSpan - 1;
  return (
    <div
      id={id}
      className={`p-2 w-screen sm:w-screen ${colSpanConfig[colSpanIndex]}`}>
      <div className={`${styles.contentBoard}`}>
        {loading ? <Spin /> : children}
      </div>
    </div>
  );
};

/**
 * Component definition of proptypes.
 */
DashboardCard.propTypes = {
  id: PropTypes.string,
  children: PropTypes.any,
  colSpan: PropTypes.number,
  loading: PropTypes.bool
};

export default DashboardCard;
